var map = {
	"./text-effect-arch.png": "e616",
	"./text-effect-circle.png": "31f6",
	"./text-effect-normal.png": "5e53",
	"./text-effect-outline.png": "af98",
	"./text-effect-psychedelic.png": "ab46",
	"./text-effect-shadow.png": "470c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";